export const WebUI = {
	smallAjaxImageTag: '<img src="/admin2/adminfiles/grfx/icon_ajax_16x16.gif" alt="Working" />',
	modalError: function (msg, closeall) {
		jQuery.ajaxWaitOver();

		if (closeall === undefined)
			closeall = true;

		if (msg == undefined)
			msg = 'Unfortunately, you have encountered an error.';

		if (closeall)
			alertify.closeAll();

		alertify.alert('<strong>Error!</strong>', '<div class="mnw-danger-box">' + msg + '</div>');
	},
	showModal: function (title, content, size, onshow) {
		//--create the element so it gets height which can be used by the modal for sizing if need be
		let div = document.createElement('div');
		div.style.display = 'none';
		div.innerHTML = content;
		document.body.appendChild(div);
		alertify.modalcontent(title, div, size, onshow);
	},
	loadModal: function (url, data, title, type, size, onshow) {
		if (type == undefined)
			type = 'GET';

		$.ajaxWait();

		$.ajax({
			url: url,
			data: data,
			type: type
		}).done(function (content) {
			WebUI.showModal(title, content, size, onshow);
			$.ajaxWaitOver();
		}).fail(WebUI.handleAjaxError);
	},
	escapeAttributeValue: function (value) {
		// As mentioned on http://api.jquery.com/category/selectors/
		return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
	},
	formatInputValueAsCurrency: function ($inputField) {
		let val = $inputField.val();

		if (val.length > 0) {
			let maxlen = parseInt($inputField.attr('maxlength'));

			if (isNaN(maxlen))
				maxlen = 99999;

			val = parseFloat(val);

			if (!isNaN(val)) {
				let formatted = val.toFixed(2);

				if (formatted.length <= maxlen)
					$inputField.val(formatted);
			}
		}
	},
	closeAllModals: function () {
		alertify.closeAll();
	},
	is_touch_device: function () {
		return (('ontouchstart' in window)
			|| (navigator.MaxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	},
	is_bs3_responsive_mode: function () {
		return $(window).width() <= 991;
	},
	is_bs5_responsive_mode: function () {
		return $(window).width() <= 1199;
	},
	handleAjaxError: function (jqxhr, textStatus) {
		let isLogon = jqxhr.getResponseHeader('LOGONREQUIRED');
		let redirect = jqxhr.getResponseHeader('AJAX_REDIRECT');

		if (redirect && redirect.length > 0) {
			jQuery.ajaxWaitOver();
			window.location = redirect;
			return false;
		}

		if (jqxhr.status == 401 || isLogon) {
			window.location = '/error/sessionexpired.php';
			return false;
		}

		WebUI.modalError();
	}
};
